import { pickBy } from 'lodash'
import { stringify } from 'qs'

import { isFalsy } from '../../core/utils'

import { httpService } from '../../common/services'

const generateUsersReport = ({
  createdByIds,
  types,
  subtypes,
  entityTypes,
  startAt,
  endAt,
}) => {
  const queryString = stringify(
    pickBy(
      {
        createdByIds,
        types,
        subtypes,
        entityTypes,
        startAt,
        endAt,
      },
      value => !isFalsy(value, { allowZero: true }),
    ),
    {
      addQueryPrefix: true,
      encode: true,
    },
  )

  return httpService.client.get(`/reports/user${queryString}`, {
    responseType: 'blob',
  })
}

export default generateUsersReport
